import React from 'react'

const FunctionsContext = React.createContext()

export default FunctionsContext
